import React, { useState } from 'react'
import { ReactComponent as YourSvg } from './right.svg';
const RecallItem = (props) => {
    const [modal,setModal] = useState(false);
    const [recall,setRecall]=useState(props.item,()=>{console.log(recall)})
    
    var model= false
    const toggleModal = () => {
        setModal(!modal)
      }
      // console.log(messages)
      const msg=[]
      recall.RecallMessage.split("|").forEach(mesg=>{
        msg.push(<p>{mesg}</p>)
      })

      const det=[]
      recall.details.split("|").forEach(detail=>{
        det.push(<p>{detail}</p>)
      })
      const imp=[]
      recall.ImprovementDetails.split("|").forEach(impr=>{
        imp.push(<p>{impr}</p>)
      })
console.log(det)
  return (
    <div>
        <YourSvg height="12px" width="12px" className="arrow"/><a onClick={toggleModal} className='hyperlink'> {recall.ImprovementCategory.RecallNumber}(準備状況などの詳細はこちら)</a>
        {modal && 
                <div className='recall-modal'>
                     <div class="modal-header">
                      <h4>{recall.RecallHeading}</h4>
                      <a onClick={toggleModal} className="close">
			
<i class="fa fa-times" aria-hidden="true"></i>
                    </a>
                      </div>
                      <div class="modal-content">
                      <div className='modal-message'>
                     {
                     msg
                     }
                     </div>
                     <div className='modal-title'><i class='circle'></i> 改善措置区分</div>
                     <div className='modal-lable'>種別&emsp;:&nbsp;{recall.ImprovementCategory.Types}</div>
                     <div className='modal-lable'>対策番号&emsp;:&nbsp;{recall.ImprovementCategory.RecallNumber}</div>
                     <div className='modal-title'><i class='circle'></i> 不具合の内容</div>
                     <div className='modal-message'>
                     {det}
                     </div>
                     <div className='modal-title'><i class='circle'></i> 改善の内容</div>
                     <div className='modal-message'>
                    {imp}
                    </div>
                     </div>
      <div class="modal-footer">
      <div className='modal-title'>本件のお問い合わせ先:</div> 
                        <div className='modal-message' >改善措置内容・修理につきましては、お近くのメルセデス・ベンツ指定サービス工場へご連絡ください。</div> 
                        <div className='modal-message'>メルセデス・ベンツ指定サービス工場へのご連絡の際には上記改善措置の種別と対策番号をお伝えください。</div> 
    </div>
                </div>
                }
    </div>
  )
}

export default RecallItem